// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1efW7","cell":"ColumnAccessor_cell__2YcXd","firstCellAccent":"ColumnAccessor_firstCellAccent__2jixu"};